import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';

export enum ID_OPPOSITION {
  ID_NESSUNA = '0',
  ID_DECRETO = '1',
  ID_PROVVEDIMENTO = '2',
}

const dataList = Object.freeze([
  {
    id: ID_OPPOSITION.ID_NESSUNA,
    value: 'Nessuna opposizione',
  },
  {
    id: ID_OPPOSITION.ID_DECRETO,
    value: "Presente decreto che rigetta l'opposizione",
  },
  {
    id: ID_OPPOSITION.ID_PROVVEDIMENTO,
    value: 'Presente provvedimento che estingue il giudizio di opposizione',
  },
]);

interface ListOppositionProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
  isSmallSize?: boolean;
  label?: string;
}

const ListOppositionComponent = ({
  disabled,
  required,
  onChange,
  value,
  error,
  isSmallSize = false,
  label = 'Opposizione',
}: ListOppositionProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={`${label}-label`}>
        {required ? `${label} *` : label}
      </InputLabel>
      <PmiSelect
        labelId={`${label}-label`}
        id={label}
        name={label}
        value={value}
        label={required ? `${label} *` : label}
        onChange={onChange}
        disabled={disabled}
        error={error}
        size={isSmallSize ? 'small' : undefined}
      >
        {dataList.map((number: ItemVM) => (
          <MenuItem key={number.id} value={number.id}>
            {number.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListOppositionComponent.displayName = 'List Opposition component';

const ListOpposition = memo(ListOppositionComponent);

export default ListOpposition as typeof ListOppositionComponent;
